import React, { Fragment } from "react";
import PropTypes from "prop-types";
//material imports
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import { ConversationDialog, calculateMessageState, RemoteContent, INITIAL_MESSAGE_RESOURCES } from "@limitless/portal";
import { useExpertProfileContext } from "@limitless/expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";

const ExpertRemoteContent = ({ ...rest }) => {
    const [message, setMessage] = React.useState();
    const { profile, isDarkMode } = useExpertProfileContext();
    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    const saveMessage = message => {
        if (message) {
            const messageWithState = calculateMessageState(profile, message, INITIAL_MESSAGE_RESOURCES);

            setMessage(messageWithState);
        }
    };

    const handleMessageDialogCancel = () => {
        setMessage();
    };

    return (
        <Fragment>
            <RemoteContent onMessageLinkClick={saveMessage} {...rest} />
            {message && (
                <ThemeProvider theme={theme}>
                    <ConversationDialog
                        headerText="Conversation"
                        message={message}
                        buttonVariant="outlined"
                        onCancelClick={handleMessageDialogCancel}
                    />
                </ThemeProvider>
            )}
        </Fragment>
    );
};

export default ExpertRemoteContent;

ExpertRemoteContent.propTypes = {
    content: PropTypes.string.isRequired,
    id: PropTypes.string
};
